module.exports = __webpack_public_path__ + "static/ofcar1-1bc359fb2c33b2b40b7d82eb1f812b95.jpg";